module.exports = __webpack_public_path__ + "media/images/city/038-clock-tower-1-66af0f0fe55d1f09b6898afa9b7d42a7.svg";